/** @module SiteAdmin/SelectSet/SelectSetFilterController */
define([
    "dojo/_base/array",
    "dojo/_base/declare",
    "csi/locale",
    "csi/prefs",
    "csi/reflection",
    "csi/xml",
    "SiteAdmin/SelectSet/SelectSetHelper",
    "Apparel/QueryFilterController"
], function(array,declare,locale,prefs,reflection,xml,SelectSetHelper,QueryFilterController) {

    return declare(QueryFilterController,{
        /**
         * @override
         * Gets type for query search from SelectSet subtype
         */
        onStart: function() {
            var node = this.getNode();
            this.queryFilterStartType = SelectSetHelper.getSubtypeName(node);
            this.queryFilterType = this.queryFilterStartType.indexOf("SupplierItem")>-1 ? "SupplierItem" : this.queryFilterStartType;
        }
    });
});